module.exports = __webpack_public_path__ + "063ffac93b531c644fa45f882c66168b.webp";